<template>
  <table id="metricActualFormTable" class="table table-sm table-condensed table-bordered table-striped table-hover">
    <thead>
    <tr>
      <th class="text-center">{{ pDictionary['dictionary.media.insertion.date'] }}</th>
      <th v-if="pKpiFieldActivationRules.costActivated"
          class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.cost.net'] }}</th>

      <th v-if="pKpiFieldActivationRules.kpiSpotsActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.spots.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiSpotsActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.spots.cost-for'] }}
      </th>

      <th v-if="pKpiFieldActivationRules.kpiPointsActivated"
          class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.points.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiPointsActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.points.cost-for'] }}
      </th>

      <th v-if="pKpiFieldActivationRules.kpiImpressionsActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.impressions.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiImpressionsActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.impressions.cost-for'] }}
      </th>

      <th v-if="pKpiFieldActivationRules.kpiActionsActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.actions.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiActionsActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.actions.cost-for'] }}
      </th>

      <th v-if="pKpiFieldActivationRules.kpiClicksActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.clicks.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiClicksActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.clicks.cost-for'] }}
      </th>

      <th v-if="pKpiFieldActivationRules.kpiLeadsActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.leads.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiLeadsActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.leads.cost-for'] }}
      </th>

      <th v-if="pKpiFieldActivationRules.kpiViewsActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.views.nb'] }}
      </th>
      <th v-if="pKpiFieldActivationRules.kpiViewsActivated && pKpiCostForActivated"
           class="metric-actual text-center" colspan="2">{{ pDictionary['dictionary.media.insertion.kpi.views.cost-for'] }}
      </th>

      <th v-if="fillerVisible">&nbsp;</th>
    </tr>
    </thead>
    <tbody>

    <metric-kpi-actual-form-table-row
        v-for="(kpiActual, index) in pKpiActualList"
        :p-currencies="pCurrencies"
        :p-language="pLanguage"
        :p-dictionary="pDictionary"
        :p-error-list="rowErrorList(index)"
        :p-index="index"
        :p-currency-ref="pCurrencyRef"
        :p-kpi-field-activation-rules="pKpiFieldActivationRules"
        :p-kpi-cost-for-activated="pKpiCostForActivated"
        :p-kpi-actual="kpiActual"
        :p-filler-visible="fillerVisible"
        :p-filler-width="fillerWidth"
        :key="kpiActualKey(kpiActual)">
    </metric-kpi-actual-form-table-row>

    </tbody>
  </table>
</template>

<script>
import MetricKpiActualFormTableRow from "@/components/common/metric/kpi/actual/form/MetricKpiActualFormTableRow";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "MetricKpiActualFormTable",
  mixins: [FormatMixin],
  components: {
    MetricKpiActualFormTableRow
  },
  props: {
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pErrorList: Object,
    pCurrencyRef: Object,
    pKpiCostForActivated: Boolean,
    pKpiFieldActivationRules: Object,
    pKpiActualList: Array
  },
  data: function () {
    return {
    }
  },
  methods: {
    kpiActualKey: function (kpiActual) {
      return kpiActual.mediaInsertionRef.id + "-"
             + kpiActual.periodStartDateText + "-"
             + kpiActual.periodEndDateText;
    },
    rowErrorList: function (index) {
      return this.errorList[index];
    }
  },
  computed: {
    fillerWidth: function () {
      return 1;
    },
    fillerVisible: function () {
      return true;
    },
    errorList: function() {
      let _component = this;
      let errorList = []
      $.each(this.pKpiActualList, function (index) {
        let fieldNamePrefix = 'bulkCmdDataForm.kpiActualList[' + index + '].';
        let formatErrorList = {};
        let myKeys = Object.keys(_component.pErrorList);
        $.each(myKeys, function (index, value) {
          if(value.indexOf(fieldNamePrefix) !== -1)
          {
            let newKey = value.replace(fieldNamePrefix, '');
            formatErrorList[newKey] = JSON.parse(JSON.stringify(_component.pErrorList[value]));
          }
        });
        errorList.push(formatErrorList);
      });

      return errorList;
    }
  }
}
</script>

<style scoped>

</style>